const remainingBalanceNegativeReducer = (state = false, action) => {
	switch(action.type){
	case 'NEGATIVE':	
		return true;
	default:
		return state;
	}
}

export default remainingBalanceNegativeReducer;